import { GetServerSideProps } from 'next';
import { ThemeProvider } from 'styled-components';

import Footer from '@/components/footer/FooterWrapper';
import HeaderRefresh from '@/components/homepageRefresh/header/Header';
import Layout from '@/components/layout/LayoutWrapper';
import blogMessages from '@/components/subpages/data/sleep/blog';
import FAQSections from '@/components/subpages/data/sleep/faq.mdx';
import heroMessages from '@/components/subpages/data/sleep/hero';
import instructorVideoMessages from '@/components/subpages/data/sleep/instructorVideo';
import { reviews, messages as reviewsMessages } from '@/components/subpages/data/sleep/reviews';
import { sections, messages as toolsMessages } from '@/components/subpages/data/sleep/tools';
import unlockMessages from '@/components/subpages/data/sleep/unlock';
import { sleepTheme } from '@/components/subpages/data/themes';
import SubpageLayout from '@/components/subpages/SubpageLayout';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const SleepSubpage = () => {
	return (
		<Layout
			customSeo={{
				title: 'Sleep Meditations, Music & Sounds - Calm',
				primaryDescription:
					"Learn how to sleep better naturally with Calm. Join the millions leveraging our sleep meditations, music, soundscapes and stories to get a good night's sleep.",
			}}
			pageName="sleep"
		>
			<ThemeProvider theme={sleepTheme}>
				<HeaderRefresh isOpaque />
				<SubpageLayout
					heroHeading={heroMessages.heading}
					heroBody={heroMessages.body}
					heroCta={heroMessages.cta}
					heroBgImage="/_n/images/subpages/sleep-hero.webp"
					mediaSectionType="instructor"
					mediaSectionHeading={instructorVideoMessages.heading}
					instructorVideoThumbnail="/_n/images/subpages/chibs-okereke-video-thumbnail-2.webp"
					instructorVideoSrc="/_n/videos/chibs-instructor-preview.mp4"
					instructorVideoCaptionsSrc="/_n/videos/chibs-instructor-preview.vtt"
					unlockHeading={unlockMessages.heading}
					unlockBody={unlockMessages.body}
					unlockBgImage="/_n/images/subpages/sleep-collage.webp"
					plansBgImage="/_n/images/subpages/sleep-plans.webp"
					reviews={reviews}
					reviewsHeading={reviewsMessages.reviewsHeading}
					blogHeading={blogMessages.heading}
					blogCategory="sleep"
					toolsSections={sections}
					toolsHeading={toolsMessages.heading}
					FaqSections={FAQSections}
				/>
			</ThemeProvider>
			<Footer />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		undefined,
		undefined,
		true,
	);

	return {
		props: {
			initialState,
		},
	};
};

export default SleepSubpage;
